import { CSSObject } from '@chakra-ui/react';

export const TopNavContainer: CSSObject = {
  mt: '0',
  px: '0',
  pt: ['1', '1.5', '0'],
  pb: '0',
  overflowX: ['scroll', null, 'auto'],
  '::-webkit-scrollbar': {
    width: '0px',
    bg: 'transparent',
    height: '0',
  },
};

export const TopNavWrapper: CSSObject = {
  overflowX: ['scroll', null, 'visible'],
  flexDir: ['row', null, 'column'],
  minW: '160px',
  bg: ['blackAlpha.500', null, null, 'alpha.600'],
  boxShadow: [
    '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 3px 5px 0px rgba(0, 0, 0, 0.2) inset',
    null,
    null,
    '0px 0px 0px 2px rgba(252, 211, 96, 1) inset, 0px 0px 0px 4px rgba(8, 13, 39, 1) inset, 0px 0px 0px 5px rgba(255, 255, 255, 0.25) inset, 0px 7px 20px 0px rgba(0, 0, 0, 0.3)',
  ],
  borderRadius: ['none', null, 'md'],
  mb: '2',
  px: ['0', '1'],
  py: ['0', '1'],
  '&::-webkit-scrollbar': { display: 'none' },
};

export const NavLink = (isActive: boolean): CSSObject => ({
  bg: [
    'transparent',
    null,
    isActive
      ? 'linear-gradient(180deg, var(--bc-colors-beta-400), var(--bc-colors-beta-300))'
      : 'transparent',
  ],
  color: [
    isActive ? 'beta.300' : 'white',
    null,
    isActive ? 'alpha.500' : 'beta.300',
  ],
  textShadow: [
    'none',
    null,
    isActive ? '0px 1px 0px rgba(255, 255, 255, 0.5)' : 'none',
  ],
  textTransform: 'uppercase',
  fontWeight: 'bold',
  fontSize: 'xs',
  lineHeight: 'normal',
  py: ['2', '2.5'],
  px: '2',
  fontFamily: 'accent',
  borderBottom: ['2px solid', null, !isActive ? '1px dashed' : 'none'],
  borderBottomColor: [
    isActive ? 'beta.300' : 'transparent',
    null,
    'rgba(0, 0, 0, 0.3)',
  ],
  borderTop: [null, null, '1px solid'],
  borderTopColor: [null, null, 'rgba(255, 255, 255, 0.05)'],
  _first: {
    borderTop: 'none',
    borderTopRadius: ['none', null, 'sm'],
  },
  _last: {
    borderBottomRadius: ['none', null, 'sm'],
    borderBottom: 'none',
  },
  '&:hover, &:focus': {
    bg: !isActive && 'blackAlpha.300',
  },
});

export const TopNavLabelWrapper: CSSObject = {
  mx: '2',
  color: 'white',
  fontFamily: 'body',
  bg: 'blackAlpha.400',
  boxShadow:
    '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 3px 5px 0px rgba(0, 0, 0, 0.2) inset',
  borderRadius: 'md',
  w: 'unset',
};

export const NavLinkLabel: CSSObject = {
  color: 'beta.400',
  textShadow: '0px 0px 9px rgba(243, 100, 23, 0.3)',
  border: 'none',
  borderBottom: '3px solid',
  borderBottomColor: 'beta.400',
  fontSize: 'xs',
  fontWeight: 'bold',
  textAlign: 'center',
  fontFamily: 'body',
  textTransform: 'uppercase',
  minHeight: '7',
  w: '90px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  h: '36px',
  ml: ['2', '4'],
};
